<!--    
@author zhijie.huang
@date 2018/9/29
@version v1.1.0
@description instanceList 实例管理 - 列表
-->
<template>
  <div class="instanceList__content">
    <g-back :history="history"></g-back>

    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item :label="$t('instanceList.version')">
        <g-select :list="versionList" v-model="form.version" :default-all="true">
          <el-option
            v-for="(sitem, skey) in versionList"
            :key="skey"
            :label="sitem"
            :value="skey">
          </el-option>
        </g-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.ip" prefix-icon="uk-icon-search" :placeholder="$t('instanceList.ip')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_search">{{ $t('common.search') }}</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-bottom: 16px;">
        <el-button v-g-rac="gRac('instanceList@start')" type="primary" @click="e_command(3)" v-text="commandList[3]" ></el-button>
        <el-button v-g-rac="gRac('instanceList@stop')" type="primary" @click="e_command(4)" v-text="commandList[4]" ></el-button>
        <el-button v-g-rac="gRac('instanceList@restart')" type="primary" @click="e_command(5)" v-text="commandList[5]" ></el-button>
        <el-button v-g-rac="gRac('instanceList@downGrade')" type="primary" @click="e_command(2)" v-text="commandList[2]" ></el-button>                    
        <el-button v-g-rac="gRac('instanceList@uninstall')" type="primary" @click="e_command(6)" v-text="commandList[6]" ></el-button>
    </div>

    <el-table-extend 
      selection
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      :selectionChange="tableSelectionChange"
      border>
    </el-table-extend>
  </div>
</template>
<script>
import rac from '@/plugins/rac-mixin'
import dic from '@/components/mixins/dic'
import table from '@/components/mixins/table'
import instanceManageBiz from '@/logic/continuousDelivery/instanceManageBiz'
import { extend } from '@/utils/tool'
import TimeFormat from '@/utils/timeFormat'

const COMMAND_CODE = {
  UPGRADE: 1,
  DOWNGRADE: 2,
  START: 3,
  STOP: 4,
  RESTART: 5,
  UNINSTALL: 6
}

const STATE_CODE = {
  START: 1,
  STOP: 2
}

export default {
  mixins: [rac, dic, table],
  data () {
    return {
      history: [],
      form: {
        group: '',
        appName: '',
        packageName: '',
        version: '',
        ip: ''
      },
      versionList: {},
      commandList: {},
      stateList: {},
      selectedRow: []
    }
  },
  methods: {
    setHistory () {
      this.history = [{ name: this.$t('instanceList.instanceList') }]
    },
    async preInitTable () {
      const pArr = [
        this.getVersion(this.form.appName),
        this.dGetDictionaryByCode('processStatus'),
        this.dGetDictionaryByCode('scriptExecuteType')
      ]
      await Promise.all(pArr)
      this.stateList = this.dDictionary.processStatus
      this.commandList = this.dDictionary.scriptExecuteType
      this.initTable()
    },
    initTable () {
      this.tInitTable({
        lanKey: 'instanceList.table',
        head: ['ip', 'version', 'preVersion', 'status', 'createTime', 'desc'],
        headOpt: {
          status: {
            formatter: 'Dictionary',
            formatterDic: this.stateList
          }
        },
        requestFun: this.search
      })
    },
    tableSelectionChange (selectList) {
      this.selectedRow = selectList
    },
    getIdList (tableArr) {
      let res = []
      if (tableArr.length > 0) {
        tableArr.map((item) => {
          res.push(item.id)
        })
      }
      return res
    },
    getStateList (tableArr) {
      let res = []
      if (tableArr.length > 0) {
        tableArr.map((item) => {
          res.push(item.status)
        })
      }
      return res
    },
    search (data) {
      const reqData = extend(true, data, this.form)
      instanceManageBiz.instanceList(reqData).then((data) => {
        if (data && data.dataList) {
          data.dataList.map((item) => {
            item.createTime = TimeFormat.getFormatTime(item.createTime)
          })
        }
        this.tData = data
      })
    },
    getVersion (appName) {
      return instanceManageBiz.getVersionList(appName).then((d) => {
        this.versionList = d
      })
    },
    getPreVersionList (tableArr) {
      let res = []
      if (tableArr.length > 0) {
        tableArr.map((item) => {
          res.push(item.preVersion)
        })
      }
      return res
    },
    checkState (td, command) {
      const stateList = this.getStateList(td)
      command = Number(command)

      let res = true
      stateList.map((item) => {
        if (command === COMMAND_CODE.START && item === this.stateList[STATE_CODE.START]) {
          res = false
        }
        if (command === COMMAND_CODE.STOP && item === this.stateList[STATE_CODE.STOP]) {
          res = false
        }
      })
      if (!res) {
        res = command === COMMAND_CODE.START ? this.$t('instanceList.tipStart') : this.$t('instanceList.tipStop')
      }
      return res
    },
    checkPreVersion (td) {
      const preVersionList = this.getPreVersionList(td)

      let res = true
      preVersionList.map((item) => {
        if (!item) {
          res = false
        }
      })
      if (!res) {
        res = this.$t('instanceList.tipDowngrade2')
      }
      return res
    },
    checkCommand (td, command) {
      const checkFun = {}
      checkFun[COMMAND_CODE.START] = this.checkState
      checkFun[COMMAND_CODE.STOP] = this.checkState
      checkFun[COMMAND_CODE.DOWNGRADE] = this.checkPreVersion

      if (checkFun[command]) {
        return checkFun[command].call(this, td, command)
      }
      return true
    },
    doCommand (command, ids) {
      instanceManageBiz.executeCommand({
        executeType: command,
        ids: ids
      }).then((d) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.search()
      })
    },
    e_search () {
      this.search(extend({}, this.form))
    },
    e_command (code) {
      code = Number(code)
      let td = this.selectedRow
      const ids = this.getIdList(td)

      const checkRes = this.checkCommand(td, code)
      if (ids.length === 0) return
      if (checkRes !== true) {
        this.$message({
          message: checkRes,
          type: 'warning'
        })
        return
      }
      if (code === COMMAND_CODE.DOWNGRADE) {
        this.$confirm(this.$t('instanceList.tipDowngrade'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          this.doCommand(code, ids)
        }).catch(() => {

        })
      } else if (code === COMMAND_CODE.UNINSTALL) {
        this.$confirm(this.$t('instanceList.tipUninstall'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          this.doCommand(code, ids)
        })
      } else {
        this.doCommand(code, ids)
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'instanceList' && from.name === 'instanceManage') {
        this.form.appName = this.$router.currentRoute.query.appName
        this.form.group = this.$router.currentRoute.query.group
        this.form.packageName = this.$router.currentRoute.query.packageName
        this.form.version = this.$router.currentRoute.query.version
        this.form.ip = ''
        this.search()
      }
    }
  },
  mounted () {
    this.form.appName = this.$router.currentRoute.query.appName
    this.form.group = this.$router.currentRoute.query.group
    this.form.packageName = this.$router.currentRoute.query.packageName
    this.form.version = this.$router.currentRoute.query.version

    this.setHistory()
    this.preInitTable()
    this.search()
  }
}
</script>